var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-message',{staticClass:"alert-count-message",attrs:{"type":"is-info"}},[_vm._v(" "+_vm._s(_setup.tc('wizards.create_care_alert.alert_count', _vm.alertCount, { number: _vm.alertCount, }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }